<template>
  <div class="history-container">
    <!-- <CuNavbar title="历史记录"></CuNavbar> -->
    <div style="text-align: center; position: relative">
      <van-image width="100%" src="/image/v2_smrous.png" />
      <div class="center">医生将会在接下来的就诊过程中和您了解更多情况</div>
    </div>
    <div class="history-title">
      <van-image src="/image/v2_smrucd.png" class="history-img" />历史记录
    </div>
    <div class="list" id="list">
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="50"
        > -->
      <van-cell v-for="item in list" :key="item.answerId" center>
        <div slot="title" class="left-title">
          <div style="display: flex; align-items: center">
            <div class="title-img">
              <van-image src="/image/v2_smrv4y.png" class="img-item" />
            </div>
            <div>
              <div style="color: #1989fa" class="title">
                <span>就诊号:</span>
                <!-- <span>25083006</span> -->
                <span>{{ item.visitNo }}</span>
              </div>
              <div class="time">{{ forMataTimer(item.createTime) }}</div>
            </div>
          </div>
          <div class="item-check-result" @click="handleBack(item)">
            点击查看
          </div>
          <!-- <div style="margin-left: 12px">{{ item.templateVersion }}</div> -->
        </div>
        <div slot="default" class="right-item">
          <van-image
            src="/image/v2_smrujh.png"
           class="images"
          />
        </div>
      </van-cell>
      <div v-if="finished" style="text-align: center;color: #1989fa;margin-top: 12px;">到底了</div>
      <!-- </van-list> -->
      <!-- </van-pull-refresh> -->
    </div>
  </div>
</template>

<script>
import CuNavbar from "@/components/CuNavbar.vue";
import { getPatientHostory } from "@/api/history.js";
import { forMataTimer } from "../../utils/day";
import debounce from "lodash.debounce";
export default {
  components: { CuNavbar },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      size: 10,
    };
  },
  mounted() {
    this.getData();
    const dom = document.getElementById("list");
    dom.addEventListener("scroll", debounce(this.handleColll, 100));
  },
  methods: {
    onLoad() {
      this.getData();
    },

    async getData() {
      if(this.finished ){
        return
      }
      const { patientId } = this.$route.query;
      const restlt = await getPatientHostory(patientId, this.page, this.size);
      if (restlt.code == 200) {
        this.list = [...this.list, ...restlt.rows] || [];
        if (this.list.length == restlt.total) {
          this.finished = true;
        }
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.page = 1;
      this.list = [];
      this.onLoad();
    },
    handleBack(item) {
      this.$router.push({
        path: "/detail",
        query: {
          id: item.answerId,
          path: "history",
        },
      });
    },
    getScrollBottomOffset(element) {
      // 获取元素的滚动高度、客户端高度和滚动位置
      const { scrollHeight, clientHeight, scrollTop } = element;
      // 返回滚动到底部的偏移量
      return scrollHeight - clientHeight - scrollTop;
    },
    handleColll() {
      const dom = document.getElementById("list");
      if (dom) {
        const height = this.getScrollBottomOffset(dom);
        if (height < 100) {
          this.page += 1;
          this.getData();
        }
      }
    },
    forMataTimer,
  },
};
</script>

<style lang="less" scoped>
.history-container {
  height: 100vh;
  .center {
    position: absolute;
    text-align: center;
    font-size: 14px;
    top: 80%;
    width: 100%;
  }
  .history-title {
    font-size: 16px;
    height: 32px;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }
  .history-img {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }
  .list {
    height: calc(100vh - 298px);
    overflow-y: auto;
    .left-title {
      display: flex;
      // align-items: center;
      width: 300px;
      // justify-content: center;
      flex-direction: column;
      margin-left: 15px;
    }
    .title-img {
      width: 36px;
      height: 36px;
      margin-right: 6px;
      .img-item {
        width: 100%;
        height: 100%;
      }
    }
    .item-check-result {
      width: 158px;
      height: 28px;
      line-height: 28px;
      color: #1989fa;
      border: 1px solid #1989fa;
      border-radius: 4px;
      text-align: center;
      margin-left: 40px;
    }
    .time,
    .title {
      width: 100%;
      margin-left: 6px;
      // padding: 0 6px;
    }
    .title {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
    }
    .van-cell__title {
      width: 70%;
    }
  }
  .images {
    width: 89px;
    height: 89px;
  }
}
</style>
